export const CLAUDIA_RATE_LIMITED_CODE = "CLAUDIA_RATE_LIMITED";
export const CLAUDIA_QUOTA_EXCEEDED_CODE = "CLAUDIA_QUOTA_EXCEEDED";

export class ClaudiaRateLimitedError extends Error {
  readonly code = CLAUDIA_RATE_LIMITED_CODE;
  readonly bucket: string;
  readonly retryAfterMs: number;

  constructor(bucket: string, retryAfterMs: number) {
    super(`${CLAUDIA_RATE_LIMITED_CODE}: ${bucket} rate limit exceeded.`);
    this.name = "ClaudiaRateLimitedError";
    this.bucket = bucket;
    this.retryAfterMs = retryAfterMs;
  }
}
